// LoginPage.js
// Shows email/password login form

import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../firebase';

function LoginPage() {
  // Form state - stores what user types
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  // Error state - shows error message if login fails
  const [error, setError] = useState('');

  // Loading state - disables button while logging in
  const [loading, setLoading] = useState(false);

  // useNavigate lets us redirect after login
  const navigate = useNavigate();

  // This function runs when user submits the form
  const handleSubmit = async (event) => {
    // Prevent page refresh (default form behavior)
    event.preventDefault();

    // Clear any previous errors
    setError('');

    // Start loading
    setLoading(true);

    try {
      // Try to sign in with Firebase Auth
      await signInWithEmailAndPassword(auth, email, password);

      // If successful, redirect to home (App.js will handle where to go)
      navigate('/');
    } catch (err) {
      // If login fails, show error message
      console.error('Login error:', err);

      // Show user-friendly error messages
      if (err.code === 'auth/user-not-found') {
        setError('No account found with this email.');
      } else if (err.code === 'auth/wrong-password') {
        setError('Incorrect password.');
      } else if (err.code === 'auth/invalid-email') {
        setError('Please enter a valid email address.');
      } else {
        setError('Failed to log in. Please try again.');
      }
    } finally {
      // Stop loading whether login succeeded or failed
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <h1>Welcome back</h1>
      <p>Log in to your Kana account</p>

      <form onSubmit={handleSubmit} className="auth-form">
        {/* Email input */}
        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@example.com"
            required
          />
        </div>

        {/* Password input */}
        <div className="form-group">
          <label htmlFor="password">Password</label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter your password"
            required
          />
        </div>

        {/* Show error if there is one */}
        {error && <p className="form-error">{error}</p>}

        {/* Submit button */}
        <button
          type="submit"
          className="button button-primary"
          disabled={loading}
        >
          {loading ? 'Logging in...' : 'Log in'}
        </button>
      </form>

      {/* Link to signup page */}
      <div className="auth-link">
        <p>
          Don't have an account? <Link to="/signup">Sign up</Link>
        </p>
      </div>
    </div>
  );
}

export default LoginPage;
